import styled from 'styled-components';

interface LoadingPulseProps {
    size?: number;
}

export default function LoadingPulse({ size = 40 }: LoadingPulseProps) {
    return (
        <Wrapper>
            <div style={{ width: size, height: size }} className='loading-pulse-body'>
                <div className='loading-pulse-element pulse-first'></div>
                <div className='loading-pulse-element pulse-second'></div>
            </div>

        </Wrapper>
    )
}

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    .loading-pulse-body { display: grid; }
    
    .loading-pulse-element {
        grid-area: 1 / 1;
        background-color: ${props => props.theme.primaryColor};
        border-radius: 50%;

        animation: pulse 1s infinite;
        &.pulse-second { animation-delay: -0.3s; }
    }

    @keyframes pulse { 0% {transform: scale(0); opacity: 1;} 100% {transform: scale(1); opacity: 0;} }
`